<template>
  <div class="checkout-panel">
    <b-overlay
      :show="showPayment"
      rounded="sm"
    >
      <template #overlay>
        <div class="text-center">
          <b-spinner
            variant="primary"
            style="width: 3rem; height: 3rem"
          />
          <p class="mt-2 mb-0">
            Procesando tu pago…
          </p>
        </div>
      </template>
      <div v-if="show">
        <div
          class="skeleton"
          style="height: 92px"
        />
        <span class="sr-only">Consultando Balance...</span>
      </div>
      <div v-else>
        <div v-if="balance_pesos <= 0">
          <b-alert
            variant="success"
            show
            class="mb-0"
          >
            <div class="alert-body">
              <feather-icon
                icon="CheckCircleIcon"
                class="mr-50"
              />
              No tiene un balance pendiente de pago. Gracias por
              mantener su cuenta al día.
            </div>
          </b-alert>
        </div>
        <div v-else>
          <div class="balance-summary">
            <small
              class="text-muted"
            >Contrato {{ contract.codigo }}</small>
            <p class="balance-summary-label mb-0">
              Total a pagar
            </p>
            <h2 class="balance-summary-amount mb-0">
              RD$ {{ balance_pesos }}
            </h2>
            <small
              class="text-muted"
            >Pesos dominicanos (DOP)</small>
          </div>

          <!-- Aceptación de términos (requisito AZUL) -->
          <div class="terms-box mt-1">
            <b-form-checkbox
              v-model="acceptTerms"
              name="accept-terms"
            >
              He leído y acepto los
              <b-link
                :to="{ name: 'legal-terms' }"
                target="_blank"
              >Términos y Condiciones</b-link>, la
              <b-link
                :to="{ name: 'legal-privacy' }"
                target="_blank"
              >Política de Privacidad</b-link>
              y las
              <b-link
                :to="{ name: 'legal-refunds' }"
                target="_blank"
              >Políticas de Devolución</b-link>.
            </b-form-checkbox>
          </div>

          <template v-if="acceptTerms">
            <div class="mt-1">
              <azul
                :contract="contract"
                :balance-pesos="balance_pesos"
              />
            </div>
          </template>
        </div>
      </div>

      <hr class="mt-3">

      <div class="text-center">
        <b-card-text class="text-muted mb-1">
          Aceptamos
        </b-card-text>
        <div
          class="d-flex justify-content-center flex-wrap payment-brand-row"
        >
          <b-img
            :src="brands.visa"
            alt="Visa"
            height="30"
          />
          <b-img
            :src="brands.mastercard"
            alt="Mastercard"
            height="30"
          />
          <b-img
            :src="brands.visaSecure"
            alt="Visa Secure"
            height="30"
          />
          <b-img
            :src="brands.mcIdCheck"
            alt="Mastercard ID Check"
            height="30"
          />
        </div>
        <small class="text-muted d-block mt-3">
          <feather-icon
            icon="LockIcon"
            size="12"
            class="mr-25"
          />Pagos procesados de forma segura por AZUL.
          <b-link
            :to="{ name: 'legal-security' }"
            target="_blank"
          >Políticas de Seguridad</b-link>
        </small>
      </div>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { fetchValidateToken } from "@/auth/EnsureTokenIsValid"
import {
  BAlert,
  BCardText,
  BFormCheckbox,
  BImg,
  BLink,
  BOverlay,
  BSpinner,
} from "bootstrap-vue"
import Azul from "./Azul.vue"

export default {
  components: {
    BOverlay,
    BCardText,
    BImg,
    BAlert,
    BSpinner,
    Azul,
    BFormCheckbox,
    BLink,
  },
  props: {
    contract: {
      type: Object,
      required: true,
    },
    idcontrato: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      balance_pesos: 0,
      showPayment: false,
      acceptTerms: false,
      brands: {
        visa: require("@/assets/images/brands/visa.jpg"),
        mastercard: require("@/assets/images/brands/mastercard.jpg"),
        visaSecure: require("@/assets/images/brands/visa-secure.png"),
        mcIdCheck: require("@/assets/images/brands/mastercard-idcheck.png"),
      },
    }
  },
  created() {
    this.searchBalance()
  },
  mounted() {
    fetchValidateToken()
  },
  methods: {
    searchBalance() {
      this.show = true
      this.$http
        .get("/contrato-balance", {
          params: {
            idcontrato: this.idcontrato,
            idusuario: this.userData.id,
            opresumen: 1,
          },
        })
        .then((response) => {
          this.show = false
          if (response.data) {
            this.balance_pesos = response.data.balance_pesos
          }
        })
        .catch((error) => {
          this.show = false
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.balance-summary {
    background-color: var(--tm-surface-muted);
    border-radius: var(--tm-radius);
    padding: 1.25rem;
}

.balance-summary-label {
    font-size: 0.875rem;
    color: var(--tm-text-secondary);
}

.balance-summary-amount {
    font-weight: 700;
}

.terms-box {
    background-color: var(--tm-surface-muted);
    border-radius: var(--tm-radius-sm);
    padding: 0.875rem;
    font-size: 0.8125rem;
}

.payment-brand-row {
    gap: 0.75rem;
}
</style>
